import styled, { css } from 'styled-components'
import { absCenter } from '../../Styles/Mixins'
import Check from 'react-feather/dist/icons/check'

export const Inner = styled.div`
  width: 100%;
  height: 100%;
  opacity: 0;
  position: relative;
`

const SelectedStyle = css`
  border: none;
  background: ${({ theme, backgroundColor }) => backgroundColor || theme.primary};
  box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, 0.2);

  ${Inner} {
    opacity: 1;
  }
`

const SmallCheckboxStyle = css`
  width: 2rem;
  height: 2rem;
`

const DefaultCheckboxStyle = css`
  width: 3rem;
  height: 3rem;
`

const DisabledStyle = css`
  cursor: default;
  opacity: .5;
  pointer-events: none;
`

const InvalidStyle = css`
  border: 2px solid ${({ theme }) => theme.error};
`

export const CheckboxWrapper = styled.div`
  border-radius: 4px;
  display: inline-block;
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border: 2px solid ${({ theme, backgroundColor }) => backgroundColor || theme.primary};
  overflow: hidden;
  cursor: pointer;

  ${DefaultCheckboxStyle}
  ${({ sm }) => sm && SmallCheckboxStyle}
  ${({ invalid }) => invalid && InvalidStyle}
  ${({ selected }) => selected && SelectedStyle}
  ${({ disabled }) => disabled && DisabledStyle}
`

export const Icon = styled(Check)`
  ${absCenter}
  ${DefaultCheckboxStyle}
  stroke: ${({ theme }) => theme.snow};
  ${({ sm }) => sm && SmallCheckboxStyle}
`

export const CheckboxWithLabelWrapper = styled.div`
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  label {
    display: inline-block;
    margin-left: 8px;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Checkbox/styles.js